import { brands } from './brands.js';

const apiUrl = import.meta.env.API_URL || '';

const accountUrl = import.meta.env.LIFEWAY_ACCOUNT_URL || 'https://account.int.lifeway.com';
const gitHash = import.meta.env.GIT_HASH || 'LOCAL';
const devTheme = import.meta.env.DEV_THEME || '';

const ENV_BY_MODE = {
  int: 'INT',
  uat: 'UAT',
  prod: 'PROD',
};

const appEnv = ENV_BY_MODE[import.meta.env.MODE] || 'INT';

const config = {
  FEATURE_TOGGLES: {
    HYFI_PREVIEW: false,
    COPY_SESSION_TIMELINE: true,
    DEBUG_ANALYTICS: false,
    PODCAST_MATERIAL: true,
    EDITABLE_SESSION_TIMELINE: true,
    REACT_EVENT_STREAM: true,
    AOM_ORG_CREATION: true,
    AOM_ORG_CONNECTION: true,
    SWITCH_CURRICULUM_SUBSCRIPTION: true,
    ASSESSMENT_V2_REPORT: true,
  },

  CURRICULUM_PRICING_VERSION: 3,

  SENTRY_RELEASE: import.meta.env.SENTRY_RELEASE || '',

  logLevel: 'warn',

  BUZZSPROUT_API_KEY: import.meta.env.BUZZSPROUT_API_KEY || '',
  INTERCOM_APP_ID: import.meta.env.INTERCOM_APP_ID || '',
  INTERCOM_AUTH_URL: import.meta.env.INTERCOM_AUTH_URL || '',
  GTM_APP_ID: import.meta.env.GTM_APP_ID || '',
  LIFEWAY_BASE_URL: import.meta.env.LIFEWAY_BASE_URL || 'https://int.lifeway.com/',
  MYLIFEWAY_BASE_URL: import.meta.env.MYLIFEWAY_BASE_URL || 'https://mlc.int.lifeway.com',
  MYLIFEWAY_CREATE_ACCOUNT_PATH: import.meta.env.MYLIFEWAY_CREATE_ACCOUNT_PATH || '/create-account/church',
};

const defaultBrand = brands.find(b => b.origin === 'GRID') ?? brands[0];

function resolveBrand() {
  const host = window.location.hostname.toLowerCase();

  // Local always uses grid.local.lifeway.com — theme comes from DEV_THEME at serve time.
  if (devTheme) {
    return brands.find(b => b.theme === devTheme) ?? defaultBrand;
  }

  // Prefer non-GRID matches so "ministrygrid" does not win over white-label hosts.
  const whiteLabel = brands.find(b => b.origin !== 'GRID' && b.hostIncludes && host.includes(b.hostIncludes));

  return whiteLabel ?? defaultBrand;
}

export const resolvedBrand = resolveBrand();

window.addEventListener('unhandledrejection', function (event) {
  console.error('Unhandled promise rejection:', event.reason);
});

// FullStory reads its org id off window.config; only Grid is tracked, and only the prod deploy sets the id.
config.FULLSTORY_ORG_ID = resolvedBrand.origin === 'GRID' ? import.meta.env.FULLSTORY_ORG_ID || '' : '';
config.activeCampaignEnabled = appEnv === 'PROD' && resolvedBrand.origin === 'GRID';

window.config = config;

window.getApiUrl = function () {
  const API_URL_HOST_OVERRIDE = {
    'bethlehem.stage.lifeway.com': 'https://ministrygrid.lifeway.com',
    'training.connexuschurch.com': 'https://training.connexuschurch.com',
    'training.centrikid.lifeway.com': 'https://training.centrikid.lifeway.com',
    'training.fuge.lifeway.com': 'https://training.fuge.lifeway.com',
    'training.studentlife.lifeway.com': 'https://training.studentlife.lifeway.com',
    'training.sbc.net': 'https://training.sbc.net',
  };

  const base = API_URL_HOST_OVERRIDE[window.location.hostname.toLowerCase()] || apiUrl;
  return base + '/api';
};

window.getAccountUrl = function () {
  if (window.location.hostname.includes('bethlehem.stage')) {
    return 'https://account.lifeway.com';
  }
  return accountUrl;
};

window.getCommitHash = function () {
  return gitHash;
};

window.getOrigin = function () {
  return resolvedBrand.origin || 'GRID';
};

window.getWhiteLabelOrgId = function () {
  const orgIds = resolvedBrand.orgIds || {};
  return orgIds[appEnv];
};

window.getIsSSO = function () {
  return Boolean(resolvedBrand.isSSO);
};
